import React from 'react';
import Plus from 'svg/PlusWithoutBG';
import Link from 'components/Link';

interface Props {
  description: string;
  actionText?: string | null;
  actionUrl?: string | null;
  actionHandler?: () => void;
}

const Wrapper = ({
  actionUrl,
  actionHandler = () => {},
  children,
}: Pick<Props, 'actionUrl' | 'actionHandler'> & { children: React.ReactNode }) => {
  return actionUrl ? (
    <Link className="w-full" href={actionUrl}>
      {children}
    </Link>
  ) : (
    <button className="w-full" onClick={actionHandler}>
      {children}
    </button>
  );
};

export default function EmptyAction({ description, actionText, actionUrl, actionHandler }: Props) {
  return (
    <Wrapper actionUrl={actionUrl} actionHandler={actionHandler}>
      <div className="mt-6 flex w-full grow flex-col items-center justify-center gap-4 rounded-lg bg-color-bg-lightmode-tertiary py-16 dark:bg-color-bg-darkmode-tertiary">
        <p className="typography-product-button-label-medium text-color-text-lightmode-tertiary dark:text-color-text-darkmode-tertiary">
          {description}
        </p>
        {actionText && (
          <div className="group flex items-center gap-ds-lg">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-color-bg-lightmode-brand px-2.5 shadow-sm transition-shadow group-hover:shadow-xl dark:bg-color-bg-darkmode-brand">
              <Plus className="w-5" />
            </div>
            <div className="typography-product-button-label-medium text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
              {actionText}
            </div>
          </div>
        )}
      </div>
    </Wrapper>
  );
}
